export default __webpack_public_path__ + "static/media/toggle.249b88b7.svg";